/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChat_user">;
    readonly " $refType": "PdpRespDealerChatLoader_user";
};
export type PdpRespDealerChatLoader_user$data = PdpRespDealerChatLoader_user;
export type PdpRespDealerChatLoader_user$key = {
    readonly " $data"?: PdpRespDealerChatLoader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLoader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerChatLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isPdpDealerChatTest",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isPdpDealerChatTest",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChat_user",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '8c26fa24dc375b079386255772812ea8';
export default node;
